// queries/getProfileBanner.ts
import { ProfileBanner } from '../types';

const staticProfileBanner: ProfileBanner = {
  backgroundImage: { url: "https://via.placeholder.com/1920x1080/1f2937/ffffff?text=Profile+Background" },
  headline: "Gourav | Freelance Software & Web Developer",
  resumeLink: { url: "https://drive.google.com/file/d/1y5DUI8_3ab6IHMr--URD3BpB9bG8-h6M/view?usp=sharing" },
  linkedinLink: "https://linkedin.com/in/bgourav2287",
  profileSummary: "Hi, I’m Gourav, a Freelance Software & Web Developer dedicated to turning ideas into high-performance web applications. I specialize in React, Next.js, and Node.js, providing end-to-end full-stack solutions. Whether you need a scalable software system or a stunning web presence, I focus on writing clean, maintainable code that solves real-world problems. Available for freelance projects and technical collaborations."
};

export async function getProfileBanner(): Promise<ProfileBanner> {
  // Simulate async behavior
  return new Promise((resolve) => {
    setTimeout(() => {
      console.log("🚀 ~ getProfileBanner ~ data:", { profilebanner: staticProfileBanner });
      resolve(staticProfileBanner);
    }, 100);
  });
}
